import { createGlobalStyle } from 'styled-components';

export const LibraryThemeStyles = createGlobalStyle`
${(props) => `
  .primary-color {
      color: ${props.theme.primary.hex} !important;
  }

  .primary-fill {
      fill: ${props.theme.primary.hex} !important;
  }

  .primary-background {
      background-color: ${props.theme.primary.hex};
  }

  .primary-border {
      border-color: ${props.theme.primary.hex};
  }

  .primary-font {
      color: ${props.theme.primaryFontColor};
  }

  .primary-font-highlight-box:before {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: ${props.theme.primaryFontColor};
      opacity: 0.08;
  }

  .primary-font-highlight-box:after {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border: 1px dashed ${props.theme.primaryFontColor};
      opacity: 0.28;
  }

  .secondary-font-highlight-box:before {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: ${props.theme.secondaryFontColor};
      opacity: 0.08;
  }

  .secondary-font-highlight-box:after {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border: 1px dashed ${props.theme.secondaryFontColor};
      opacity: 0.28;
  }

  .Hero .Hero-banner{
      background: ${props.theme.primary.hex} !important;
  }

  .Hero .Hero-collectionInfo, .Hero .Hero-collectionTitleLink, .Hero .Hero-seeAll {
      color: ${props.theme.primaryFontColor};
  }

  .Campaign {
      background: ${props.theme.primary.hex} !important;
  }

  .Campaign-title {
      color: ${props.theme.primaryFontColor};
  }

  .Campaign-monochrome-svg {
      fill: ${props.theme.primaryFontColor};
  }

  .Campaign-featuredTitle, .Campaign-featuredTitle:hover {
      color: ${props.theme.primaryFontColor};
  }

  .Campaign-author, .Campaign-author:hover {
      color: ${props.theme.primaryFontColor};
  }

  .Campaign-learnMoreLink, .Campaign-author:hover {
      color: ${props.theme.primaryFontColor};
  }

  .Campaign-description, .Campaign-description {
      color: ${props.theme.primaryFontColor};
  }

  .Campaign-audiobookLink, .Campaign-audiobookLink:hover, .Campaign-audiobookLink:focus {
      color: ${props.theme.primaryFontColor};
  }

  .Loans-learnMoreLink {
      color: ${props.theme.primary.hex} !important;
  }

  .Loans-learnMoreLink:hover {
      color: ${props.theme.secondary.hex} !important;
  }

  .button.place-a-hold.Button-holdButton {
      background: ${props.theme.secondary.hex} !important;
      border: 2px solid ${props.theme.secondary.hex} !important;
      color: ${props.theme.secondaryFontColor} !important;
  }

  .button.place-a-hold.Button-holdButton:hover {
      background:rgb(${props.theme.secondary.r - 10}, ${
    props.theme.secondary.g - 10
}, ${props.theme.secondary.b - 10}) !important;
      border: 2px solid rgb(${props.theme.secondary.r - 10}, ${
    props.theme.secondary.g - 10
}, ${props.theme.secondary.b - 10});
  }

  .AccountPageMenu-tabListItem {
      border-color: ${props.theme.primary.hex} !important;
  }
      
  .primary-color-hover:hover {
      color: ${props.theme.primary.hex}!important;
  }

  .primary-color-focus:focus {
      color: ${props.theme.primary.hex}!important;
  }

  .secondary-color {
      color: ${props.theme.secondary.hex} !important;
  }

  .secondary-fill {
      fill: ${props.theme.secondary.hex} !important;
  }

  .secondary-color-hoverable {
      color: ${props.theme.secondary.hex};
  }

  .secondary-color-hoverable:hover, .secondary-color-hoverable:focus {
      color: rgb(${0.8 * props.theme.secondary.r}, ${
    0.8 * props.theme.secondary.g
}, ${0.8 * props.theme.secondary.b});
  }

  .secondary-background {
      background: ${props.theme.secondary.hex} !important;
      color: ${props.theme.secondaryFontColor} !important;
  }

  .secondary-color-hover:hover {
      ${
          props.theme.bannerIsSecondaryColor
              ? `color: ${props.theme.secondaryFontColor}`
              : `color: ${props.theme.secondary.hex} !important`
      }
  }

  .secondary-background-hover:hover {
      background: ${props.theme.secondary.hex} !important;
  }

  .secondary-color-focus:focus {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondary.hex}`
            : `color: ${props.theme.secondary.hex} !important`
    }
  }

  .secondary-border-color {
      border-color: ${props.theme.secondary.hex} !important;
  }

  .secondary-underline {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondary.hex}`
            : `color: ${props.theme.secondary.hex} !important`
    }
      text-decoration: underline;
  }

  .spinner {
    ${
        props.theme.secondaryFontColor === '#000'
            ? `
        border-bottom: 4px solid rgba(0, 0, 0, .2);
        border-left: 4px solid rgba(0, 0, 0, .2);
        border-right: 4px solid rgba(0, 0, 0, .2);
        border-top: 4px solid rgba(0, 0, 0, .8);
      `
            : `
        border-bottom: 4px solid rgba(255, 255, 255, .2);
        border-left: 4px solid rgba(255, 255, 255, .2);
        border-right: 4px solid rgba(255, 255, 255, .2);
        border-top: 4px solid rgba(255, 255, 255, .8);
      `
    }
  }

  .nav-container:not(.ntc), .MergedSite .Header {
      border-top:4px solid ${props.theme.secondary.hex};
      ${
          props.theme.bannerIsSecondaryColor
              ? `background-color: ${props.theme.secondary.hex};`
              : 'background-color:#fff;'
      }
  }

  .notificationDotContainer{
    ${
        props.theme.bannerIsSecondaryColor
            ? `background-color: ${props.theme.secondary.hex};`
            : 'background-color:#fff;'
    }
  }

  .BrowseFormats .BrowseFormats-link:after, .BrowseFormats .BrowseFormats-link.is-active:after {
      background-color: ${props.theme.primary.hex};
  }

   a.sign-in, a.sign-in-mobile {
      background: ${props.theme.secondary.hex} !important;
  }

  a.sign-in:hover, a.sign-in-mobile:hover {
      background: rgb(${props.theme.secondary.r - 10}, ${
    props.theme.secondary.g - 10
}, ${props.theme.secondary.b - 10}) !important;
  }

  .icon-account.expanded {
      color:${props.theme.secondary.hex}!important;
  }
  
  .top-bar-section ul li{
      color:${props.theme.defaultColor};
      background: #fff;
  }

  .top-bar-section ul li:hover{
      color: ${props.theme.secondary.hex};
      background: #fff;
  }

  .top-bar-section ul:not(.open) li:not(.has-form) a:not(.button):not(.close-advantage-tout) {
    ${
        props.theme.bannerIsSecondaryColor
            ? `
      color: ${props.theme.secondaryFontColor};
      background-color: ${props.theme.secondary.hex};
      `
            : `
      color: ${props.theme.defaultColor};
      background-color:#fff;
      `
    }
  }

  .notification-bell-svg{
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        fill: ${props.theme.secondaryFontColor};
        stroke: ${props.theme.secondaryFontColor};
      `
            : `
        fill: ${props.theme.defaultColor};
        stroke: ${props.theme.defaultColor};
      `
    }
  }

  .top-bar-section ul:not(.open) li:not(.has-form) a:not(.button):not(.close-advantage-tout):hover {
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        color: ${props.theme.secondaryFontColor};
        background-color: ${props.theme.secondary.hex};
      `
            : `
        color: ${props.theme.secondary.hex};
        background-color: #fff;
      `
    }
  }
  
  .top-bar-section ul .open li:not(.has-form) a:not(.button):not(.close-advantage-tout) {
      color: ${props.theme.defaultColor};
      background-color:#fff;
  }
  .top-bar-section ul .open li:not(.has-form) a:not(.button):not(.close-advantage-tout):hover {
      color: ${props.theme.secondary.hex};
      background-color: #fff;
  }

  .content.f-dropdown div li h2, .content.f-dropdown div h2 {
      color: ${props.theme.primary.hex}
  }

  .title-details .loan-button-audiobook .accordion .accordion-navigation a.primary:focus {
    box-shadow: none;
    color: #fff;
  }

  .title-details .loan-button-audiobook .accordion .accordion-navigation a.primary:hover {
    color: #fff;
  }

  .top-bar.expanded .toggle-topbar.menu-icon {
      color: ${props.theme.secondary.hex};
  }

  nav.top-bar{
    ${
        props.theme.bannerIsSecondaryColor
            ? `background-color: ${props.theme.secondary.hex};`
            : 'background-color:#fff;'
    }
  }


  nav.top-bar li.search-icon i.expanded {
      color: ${props.theme.secondary.hex};
  }

  .top-bar.expanded .toggle-topbar.browse a{
      color: ${props.theme.secondary.hex};
  }
  ul.account-menu li a.selected {
      border-bottom: 3px solid ${props.theme.primary.hex};
  }
  ul#lending-period-options.f-dropdown li a:hover, ul#lending-period-options-mobile.f-dropdown li a:hover, ul#lending-period-options.f-dropdown li a:after, ul#lending-period-options-mobile.f-dropdown li a:after {
      color: ${props.theme.secondary.hex};
  }

  ul.pagination li.current a, ul.pagination li.current button {
      color: ${props.theme.primary.hex};
      border:2px solid ${props.theme.primary.hex};
  }

  ul.pagination li.current a:focus, ul.pagination li.current a:hover, ul.pagination li.current button:focus, ul.pagination li.current button:hover {
      background: ${props.theme.primary.hex};
  }

  .sample-only-banner,
  .Toaster-toast:not(.is-burnt) {
    ${
        props.theme.bannerIsSecondaryColor
            ? `background: rgb(${props.theme.secondary.r - 20}, ${
                  props.theme.secondary.g - 20
              }, ${props.theme.secondary.b - 20});`
            : `background-color:${props.theme.secondary.hex};`
    }
    color: ${props.theme.secondaryFontColor};
  }

  .sample-only-banner__message h1,
  .sample-only-banner__message h2,
  .sample-only-banner__message h3,
  .sample-only-banner__message h4,
  .sample-only-banner__message h5,
  .sample-only-banner__message h6 {
    color: ${props.theme.secondaryFontColor};
  }

  .sample-only-banner__message a,
  .Toaster-message a {
      color: ${props.theme.secondaryFontColor};
  }

  .sample-only-banner__message a:hover,
  .sample-only-banner__message a:focus,
  .Toaster-message a:hover, 
  .Toaster-toast a:focus {
      color: ${props.theme.secondaryFontColor};
  }

  div.skip-links {
      background-color: ${props.theme.secondary.hex};
  }

  .Skip-Links .SkipLinks-link {
      color: ${props.theme.secondaryFontColor};
  }

  .media-container.list-view ul li .title-container div.title-description a.expand-description:hover {
      color:rgb(${props.theme.secondary.r - 10}, ${
    props.theme.secondary.g - 10
}, ${props.theme.secondary.b - 10}) !important;
  }

  .media-container .more-actions:hover i:before, .media-container .more-actions:focus i:before, .more-actions-container.holds .more-actions:hover i:before, .more-actions-container.holds .more-actions:focus i:before, .more-actions-container.holds .more-actions.open i:before {
      color: ${props.theme.secondary.hex} !important;
  }

  .title-container .title-contents .more-actions.dot-menu.open i:before, .title-container .title-contents .more-actions.dot-menu:hover i:before {
      color: ${props.theme.secondaryFontColor} !important;
  }

  .view-as-grid, .view-as-grid:hover, .view-as-grid:focus, .view-as-list, .view-as-list:hover, .view-as-list:focus .view-as-grid i:not(.gray), .view-as-grid:hover i:not(.gray), .view-as-grid:focus i:not(.gray), .view-as-list i:not(.gray), .view-as-list:hover i:not(.gray), .view-as-list:focus i:not(.gray) {
      color: ${props.theme.secondary.hex} !important;
  }

  .accordion-navigation .content a li:hover {
      color: ${props.theme.secondary.hex}
  }

  .library-card-sign-up a:hover {
      color: ${props.theme.primary.hex};
  }

  li.collection-link:hover i, a.view-all-collections:hover i {
      color: ${props.theme.primary.hex} !important;
  }

  div#main ul li a.subject-link:hover {
      color: ${props.theme.secondary.hex};
  }

  span.selected, span.selected:hover {
      border-color:${props.theme.secondary.hex};
  }

  .collection-link.primary-color-hover:hover span.selected {
      border-color:${props.theme.primary.hex}
  }

  .SearchResultMessage-dismiss {
      color: ${props.theme.secondary.hex};
  }

  .Autocompletions .Autocompletions-item.is-active {
      border-left: solid 2px ${props.theme.secondary.hex} !important;
  }

  .Facets-sectionListItem:hover .Facets-sectionListItemLink {
      color: ${props.theme.secondary.hex};
  }

  .Nav-searchIcon--desktop.is-selected {
      border-bottom: 2px solid ${props.theme.secondary.hex};
  }

  .Nav-searchIcon--desktop.is-submit {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.secondary.hex};`
    }
  }

  .Nav-searchIconContainer:hover .Nav-searchText, .Nav-searchIconContainer:hover .Nav-searchIcon--desktop{
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.secondary.hex};`
    }
  }

  .Nav-collectionsLink:hover .Nav-collectionsDropArrow, .Nav-myAccount--desktop:hover .Nav-accountDropArrow {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.secondary.hex} !important;`
    }
  }

  .Nav-collectionsDropLink.open .Nav-collectionsDropArrow {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.secondary.hex} !important;`
    }
  }

  .Nav-room-logo--desktop, .MobileNav-roomLibraryName {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.secondary.hex} !important;`
    }
  }

  .DesktopNavLinks .DesktopNavLinks-link {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.defaultColor};`
    }
  }

  .DesktopNavLinks .DesktopNavLinks-link a:hover {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.defaultColor};`
    }
  }


  .Nav-accountDropArrow {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.defaultColor};`
    }
  }

  .Nav-collectionsDropArrow {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.defaultColor};`
    }
  }

  .Nav-searchIcon--desktop {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.defaultColor};`
    }
  }

  .Nav-bookshelfIcon--desktop {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.defaultColor};`
    }
  }

  .Nav-advancedSearch {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.defaultColor};`
    }
  }

  .Nav-advancedSearchCaret {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: #222;`
    }
  }

  .getACardPromoHeader p {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: #222;`
    }
  }

  .MobileNav {
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        background-color: ${props.theme.secondary.hex};
        color: ${props.theme.secondaryFontColor};
      `
            : `
        background-color: #fff;
        color: ${props.theme.defaultColor};
      `
    }
  }

  .MobileNav-bookshelfIcon {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: #222;`
    }
  }

  .MobileNav-hamburgerIcon {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: #222;`
    }
  }

  .MobileNav-submitSearch {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: #222;`
    }
  }
  .body:not(.is-contrasted) .MobileNav-advancedSearch{
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        color: ${props.theme.secondaryFontColor};
        background-color: ${props.theme.secondary.hex};
      `
            : `
        color: #000;
        background-color: #fff;
      `
    }
  }

  .body:not(.is-contrasted) .MobileNav-searchInput {
      ${
          props.theme.bannerIsSecondaryColor
              ? `color: ${props.theme.secondaryFontColor}!important;`
              : ''
      }
  }

  .body:not(.is-contrasted) .MobileNav-searchInput::-webkit-input-placeholder {
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        color: ${props.theme.secondaryFontColor};
        opacity: .7;
      `
            : ''
    }
  }
  .body:not(.is-contrasted) .MobileNav-searchInput::-moz-placeholder {
      ${
          props.theme.bannerIsSecondaryColor
              ? `
          color: ${props.theme.secondaryFontColor};
          opacity: .7;
        `
              : ''
      }
  }

  .body:not(.is-contrasted) .MobileNav-searchInput:-moz-placeholder {
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        color: ${props.theme.secondaryFontColor};
        opacity: .7;
      `
            : ''
    }
  }

  .body:not(.is-contrasted) .MobileNav-searchInput::-ms-input-placeholder {
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        color: ${props.theme.secondaryFontColor};
        opacity: .7;
      `
            : ''
    }
  }


  .MobileNav-searchInput {
          background: none !important;
  }

  .body:not(.is-contrasted) .Nav .Nav-searchBar {
      ${
          props.theme.bannerIsSecondaryColor
              ? `border-bottom: 1px solid ${props.theme.secondaryFontColor}!important;`
              : `border-bottom: 1px solid #ccc;`
      }
  }

  .body.is-contrasted .Nav .Nav-searchBar {
      border-bottom: 1px solid #fff !important
  }

  .body:not(.is-contrasted) .Nav-searchInput::-webkit-input-placeholder {
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        color: ${props.theme.secondaryFontColor};
        opacity: .7;
      `
            : ''
    }
  }

  .body:not(.is-contrasted) .Nav-searchInput::-moz-placeholder {
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        color: ${props.theme.secondaryFontColor};
        opacity: .7;
      `
            : ''
    }
  }

  .body:not(.is-contrasted) .Nav-searchInput:-moz-placeholder {
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        color: ${props.theme.secondaryFontColor};
        opacity: .7;
      `
            : ''
    }
  }

  .body:not(.is-contrasted) .Nav-searchInput::-ms-input-placeholder {
    ${
        props.theme.bannerIsSecondaryColor
            ? `
        color: ${props.theme.secondaryFontColor};
        opacity: .7;
      `
            : ''
    }
  }

  .body:not(.is-contrasted) .MobileNav-roomLogo, .Nav-room-sub-logo--desktop  {
      ${
          props.theme.bannerIsSecondaryColor
              ? `color: ${props.theme.secondaryFontColor};`
              : `color: #666;`
      }
  }

  .Nav-backToMainCollection {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor};`
            : `color: ${props.theme.defaultColor};`
    }
  }

  .Nav-topRightLink:not(:first-child) {
    ${
        props.theme.bannerIsSecondaryColor
            ? `border-left: 1px solid ${props.theme.secondaryFontColor};`
            : `border-left: 1px solid #cdccd1;`
    }
  }


  .body:not(.is-contrasted) .search-bar input {
    ${
        props.theme.bannerIsSecondaryColor
            ? `color: ${props.theme.secondaryFontColor}!important;`
            : ''
    }
  }

  .search-bar input {
    ${
        props.theme.bannerIsSecondaryColor
            ? `background: none !important;`
            : `background: #fff !important;`
    }
  }

  .body:not(.is-contrasted) .Nav-clearSearch, .body:not(.is-contrasted) .MobileNav-clearSearchIcon  {
    ${
        props.theme.bannerIsSecondaryColor
            ? `background: rgb(${props.theme.secondary.r - 20}, ${
                  props.theme.secondary.g - 20
              }, ${props.theme.secondary.b - 20}) !important;`
            : `background: #999;`
    }
  }

  p.advantage-tout-text {
      color: ${props.theme.defaultColor};
  }

  p.advantage-tout-text:hover {
      color: ${props.theme.defaultColor};
  }
}
`}`;
